import {Input} from 'antd'
import {getId} from 'apis/model/base'
import FieldsFactory from 'components/form/FieldsFactory'
import {ResetButton, SubmitButton} from 'components/form/FormActionBar'
import Pure from 'components/Pure'
import {Formik} from 'formik'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import withTranslate from 'modules/local/withTranslate'
import React, {useMemo} from 'react'
import {compose, mapProps, nest, pure} from 'recompose'
import {createControlledFormField} from 'views/AppLocals/factory/createFormField'
import {NullAsDefault, shallowDiff} from 'views/Shared'
import {ActionModalWrapper} from "../../../../components/form/ActionModalWrapper";
import TooltipApp from "../../../../components/TooltipApp";
import {createSelectValue} from "../../../../components/form/utils";
import {SelectWidget} from "../../custom/ReactSelectComponents";
import Translate from "../../../../modules/local/Translate";
import LookupField from "../../../../components/LookupField";
import {createDateComponent} from "../../../../components/form/fields/DateField";
import {AnnouncementTypes} from "../consts/AnnouncementTypes";
import PhotoField from "../../custom/PhotoField";
import {BiSolidChurch} from "react-icons/bi";
import dayjs from "dayjs";
import {
    eachWordUppercase, lengthBetween,
    noDoubleSpaces,
    noLeadingTrailingSpaces, noNumber,
    noSpecialChars,
    required, runRules
} from "../../../../components/form/ValidateForm";

const formSchema = {
    title: {
        title: 'title',
        children: [
            {
                name: 'title',
                component: compose(
                    withTranslate,
                    mapProps(({name, value, translate, onChange}) => ({
                        showCount: true,
                        maxLength: 180,
                        name,
                        value,
                        onChange,
                        placeholder: translate('title'),
                    })),
                    pure
                )(Input),
            },
        ],
    },

    content: {
        title: 'content',
        children: [
            {
                name: 'content',
                component: createControlledFormField({
                    showCount: true,
                    maxLength: 500,
                    rows: 5,
                    placeholder: 'content',
                    Component: Input.TextArea,
                }),
            },
        ],
    },
    photo: {
        title: 'image',
        children: [
            {
                name: 'photo',
                component: ({name, value, form, onChange}) => (
                    <div className="flex flex-col gap-1">
                        <PhotoField
                            holder={<BiSolidChurch/>}
                            className="background"
                            style={{padding: 0}}
                            values={_.get(form, 'values')}
                            {...{name, value, onChange}}
                        />
                        <div className="text-center text-xs text-color-500 italic">{`* 800 x 600`}</div>
                    </div>
                ),
            },
        ],
    },
    shared_url: {
        title: 'shared url',
        children: {
            name: 'shared_url',
            component: compose(
                withTranslate,
                mapProps(({ value, onChange, meta, translate }) => {
                    const error = meta?.error;
                    const touched = meta?.touched;

                    return {
                        value,
                        onChange,
                        name: 'shared_url',

                        title: touched && error ? error : '',
                        open: touched && !!error,

                        status: touched && error ? 'error' : '',

                        addonBefore: 'https://...',
                        placeholder: translate('please input url'),
                        type: 'text',
                    };
                }),
                // mapProps(({onChange, value, translate}) => ({
                //     onChange,
                //     value,
                //     name: 'shared_url',
                //     addonBefore: 'https://...',
                //     placeholder: translate('please input url'),
                //     type: 'text',
                //     trigger: ['focus'],
                //     placement: 'topLeft',
                // })),
                pure
            )(nest(TooltipApp, Input)),
        },
    },

    department_in_organization: {
        title: 'choose group / ministry',
        children: [
            {
                name: 'organization_department_id',
                component: compose(
                    withTranslate,
                    mapProps(({name, translate, onChange, value, form, ...restForm}) => {

                        const options = form?.values?.organization_departments?.map(e => {
                            return {value: e.id, label: `${e?.title} (${e?.member_count} ${translate('members')})`}
                        })
                        return {
                            name,
                            allowClear: true,
                            className: 'w-full',
                            value: value || undefined,
                            onChange: (value) => {
                                onChange(createSelectValue('organization_department_id', value))
                            },
                            placeholder: translate('notify all groups'),
                            options: options,
                        }
                    }),
                    pure
                )(SelectWidget),
            },
        ],
    },
    category: {
        title: 'announcement type',
        children: [
            {
                name: 'type',
                component: ({name, value, onChange, form}) => {
                    const values = _.get(form, 'values', {})
                    const organization = _.get(values, 'organization', {})
                    return (
                        <Translate>
                            {(t) => (
                                <LookupField
                                    createIfNotExists={true}
                                    defaultValue={values?.type_label}
                                    valueType="value"
                                    apiPath={`/lookup/organization_announcement_type/gets?group_type=organization_announcement_${organization?.org_type}`}
                                    name={name}
                                    placeholder={t('choose or create')}
                                    handleChange={(e) => {
                                        form.setValues({
                                            ...form.values,
                                            type_label: e?.target?.value,
                                            type_code: e.target.code,
                                        });
                                    }}
                                    renderOption={(o, i) => {
                                        return (
                                            <div key={i} className="flex items-center gap-3 flex-1">
                                                {_.find(AnnouncementTypes, {value: o?.code})?.icon}
                                                <div className="flex flex-col flex-1">
                                                    <div
                                                        className="font-bold text-base text-color-000 tracking-wide leading-snug">
                                                        {t(o?.label)}
                                                    </div>
                                                    <div className="text-xs text-color-300 italic leading-snug">
                                                        {o?.label}
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    }}
                                />
                            )}
                        </Translate>
                    )
                },
            },
        ],
    },

    started_finished_date: {
        inline: true,
        className: 'grid grid-cols-1 md:grid-cols-2 gap-3',
        children: [
            {
                name: 'time_open',
                label: 'started at',
                component: createDateComponent(),
            },
            {
                name: 'time_close',
                label: 'finished at',
                component: createDateComponent(),
            },
        ],
    },
}

const validateTitle = (title, t) => {
    const rules = [
        required(t),
        noLeadingTrailingSpaces(t),
        noDoubleSpaces(t),
    ].filter(Boolean)
    const message = runRules(title, rules)
    if(message) return {title: message}
}

const validateType = (typeName, t) => {
    const rules = [
        lengthBetween(1, 120, t),
        noNumber(t),
        noSpecialChars(t),
        noLeadingTrailingSpaces(t),
        noDoubleSpaces(t),
    ].filter(Boolean)
    const message = runRules(typeName, rules)
    if(message) return {type: message}
}

const validateShareUrl = (shareUrl, t) => {
    if (!shareUrl) return {}
    try {
        const u = new URL(
            /^https?:\/\//i.test(shareUrl)
                ? shareUrl
                : 'https://' + shareUrl
        )
        if (!u.hostname.includes('.')) {
            return { shared_url: t('invalid url') }
        }
        return {}
    } catch {
        return { shared_url: t('invalid url') }
    }
}

const validateTimeOpen = (timeOpen, typeForm, t) => {
    const rules = [required(t)].filter(Boolean)
    const message = runRules(timeOpen, rules)
    if (message) return { time_open: message }
    if (typeForm === 'Create') {
        const selected = dayjs(timeOpen).startOf('day')
        const today = dayjs().startOf('day')
        if (selected.isBefore(today)) {
            return { time_open: t('start date must be today or later') }
        }
    }
}

const validateTimeClose = (timeOpen, timeClose, t) => {
    const rules = [required(t)].filter(Boolean)
    const message = runRules(timeClose, rules)
    if (message) return { time_close: message }

    const start = dayjs(timeOpen).startOf('day')
    const end = dayjs(timeClose).startOf('day')
    if (end.isBefore(start)) {
        return { time_close: t('end date must be same as or after start date') }
    }
}

const validate = (t, typeForm) => (values) => {
    const {
        title,
        content,
        photo,
        shared_url,
        type_label,
        time_open,
        time_close
    } = values ?? {}
    const errorTitle = validateTitle(title, t)
    const errorType = validateType(type_label, t)
    const errorShareUrl = validateShareUrl(shared_url, t)
    const errorTimeOpen = validateTimeOpen(time_open, typeForm, t)
    const errorTimeClose = validateTimeClose(time_open, time_close, t)
    return {
        ...errorTitle,
        ...errorType,
        ...errorShareUrl,
        ...errorTimeOpen,
        ...errorTimeClose,
    }
}

export const OrganizationAnnouncementCreateForm = ({
                                                       organization,
                                                       organizationDepartments,
                                                       initialValues,
                                                       onSubmit = NullAsDefault,
                                                       isSubmitting = false,
                                                   }) => {
    const t = useTranslate()
    const _initialValues = useMemo(
        () => ({
            title: undefined,
            content: undefined,
            photo: undefined,
            organization_departments: organizationDepartments,
            organization_id: organization?.id,
            time_open: dayjs().set("hour", 0).set("minute", 0).set("second", 0),
            time_close: dayjs().add(7, 'day').set("hour", 0).set("minute", 0).set("second", 0),
            type_label: t('ANNOUNCEMENT'), type_code: 'ANNOUNCEMENT',
            ...(initialValues ?? {}),
        }),
        [organization, initialValues]
    )

    return (
        <Formik
            validate={validate(t, 'Create')}
            validateOnMount={true}
            validateOnChange={true}
            enableReinitialize={true}
            initialValues={_initialValues}
            onSubmit={(values) => {
                const {
                    organization, organization_departments, photo_preview, shared_url,
                    ...rest
                } = values ?? {};

                // normalize nếu cần
                const normalizedUrl = shared_url
                    ? (/^https?:\/\//i.test(shared_url)
                        ? shared_url
                        : 'https://' + shared_url)
                    : shared_url;

                onSubmit(
                    _.omitBy(
                        {
                            shared_url: normalizedUrl,
                            ...rest,
                        },
                        _.isUndefined
                    )
                )
            }}>
            <ActionModalWrapper
                className="gap-3"
                action={
                    <div className="flex items-center justify-end p-2 background">
                        <ResetButton disabled={isSubmitting}/>
                        <SubmitButton
                            label="create"
                            dirtyRequired={false}
                            loading={isSubmitting}
                        />
                    </div>
                }>
                <FieldsFactory
                    formSchema={[
                        formSchema.photo,
                        formSchema.department_in_organization,
                        formSchema.title,
                        formSchema.category,
                        formSchema.content,
                        formSchema.started_finished_date,
                        formSchema.shared_url,
                    ]}
                />

            </ActionModalWrapper>
        </Formik>
    )
}

export const OrganizationAnnouncementUpdateForm = ({
                                                       organization,
                                                       organizationDepartments,
                                                       initialValues,
                                                       onSubmit = NullAsDefault,
                                                       isSubmitting = false,
                                                   }) => {
    const t = useTranslate()
    const organization_id = getId(organization)
    const _initialValues = useMemo(() => {
        const {...rest} = initialValues ?? {}
        return {
            organization_id,
            organization_departments: organizationDepartments,
            organization_department_id: rest?.organization_department?.id,
            organization,
            photo_preview: rest.photo,
            ...rest,
        }
    }, [organization_id, initialValues]);

    return (
        <Formik
            validate={validate(t, 'Edit')}
            validateOnMount={true}
            validateOnChange={true}
            enableReinitialize={true}
            initialValues={_initialValues}
            onSubmit={(values) => {
                const changes = shallowDiff(values, _initialValues)
                const {
                    shared_url,
                    ...rest
                } = changes ?? {}

                // normalize nếu cần
                const normalizedUrl = shared_url
                    ? (/^https?:\/\//i.test(shared_url)
                        ? shared_url
                        : 'https://' + shared_url)
                    : shared_url;

                onSubmit(
                    _.omitBy(
                        {
                            shared_url: normalizedUrl,
                            ...rest,
                        },
                        _.isUndefined
                    )
                )
            }}>
            <ActionModalWrapper
                className="gap-4"
                action={
                    <div className="flex items-center justify-end p-2 background">
                        <ResetButton disabled={isSubmitting}/>
                        <SubmitButton
                            label="save"
                            dirtyRequired={false}
                            loading={isSubmitting}
                        />
                    </div>
                }>
                <Pure>
                    <FieldsFactory
                        formSchema={[
                            formSchema.photo,
                            formSchema.title,
                            formSchema.category,
                            formSchema.content,
                            formSchema.started_finished_date,
                            formSchema.shared_url,
                        ]}
                    />
                </Pure>
            </ActionModalWrapper>
        </Formik>
    )
}

